import ar from '@/local/ar.js';
import CaseRelatedRequest from '../pages/case-related-request';
import CaseRelatedProcedure from '../pages/case-related-procedure';
import CasedigitalizationRequest from '../components/case-related-request/case-digitalization-request.vue';
import ViewIncomingRequest from '../components/case-related-request/view-incoming-requests/index.vue';
import CaseRelatedRequestSearch from '../pages/case-related-request-search';
import CaseFile from '../pages/case-file.vue';
import SelectCaseRelatedRequest from '../pages/select-case-related-request.vue';
import WrittenPleading from '../pages/written-pleading.vue';
import LawsuitReplyForm from '../pages/lawsuit-reply-form.vue';
import ReconsiderationFromNonCaseParty from '../components/case-related-request/reconsideration-from-non-case-party/index.vue';
import ViewReconsiderationFromNonCaseParty from '../components/case-related-request/reconsideration-from-non-case-party/view-reconsideration-from-non-case-party/index.vue';
import PetitionRequests from '../../../modules/global/components/home-page/petition-requests';
import Waiver from '../../../modules/global/components/home-page/waiver-requests';
import CorrectionDecisions from '../../../modules/global/components/home-page/correction-decisions';
import PrintLawsuitPaper from '../pages/print-lawsuit-paper.vue';

export default [
  {
    path: '/cases/:objectKey/print',
    name: 'print-lawsuit-paper',
    component: PrintLawsuitPaper,
    meta: {
      noBreadcrumbs: true,
    },
  },
  {
    path: '/cases/case-related-request/:requestType/:requestObjectKey',
    name: 'view-case-related-request',
    component: CaseRelatedRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
      replyToRequest: false,
    },
  },
  {
    path: '/cases/:requestType/file/:requestObjectKey',
    name: 'view-reconsideration-from-non-case-party',
    component: ViewReconsiderationFromNonCaseParty,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.reconsiderationFromNonCaseParty,
        isDynamic: false,
      },
      replyToRequest: false,
    },
  },
  {
    path: '/cases/case-related-procedure/:requestType/:requestObjectKey',
    name: 'view-case-related-procedure',
    component: CaseRelatedProcedure,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedProcedure,
        isDynamic: false,
      },
      replyToRequest: false,
    },
  },
  {
    path: '/cases/case-related-request/:requestType/reply/:requestObjectKey',
    name: 'reply-case-related-request',
    component: CaseRelatedRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
      replyToRequest: true,
    },
  },
  {
    path: '/cases/case-digitalization-request/:requestType',
    name: 'case-digitalization-request',
    component: CasedigitalizationRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseDigitalizationRequest,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/reconsideration-from-non-case-party/:requestType/:isNew',
    name: 'reconsideration-from-non-case-party',
    component: ReconsiderationFromNonCaseParty,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.reconsiderationFromNonCaseParty,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/:caseObjectKey/case-related-request/:requestType/:requestObjectKey',
    name: 'case-related-request',
    component: CaseRelatedRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
      replyToRequest: false,
    },
  },
  {
    path: '/cases/case-related-request',
    name: 'case-related-request-search',
    component: CaseRelatedRequestSearch,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/new-case-related-request',
    name: 'select-case-related-request',
    component: SelectCaseRelatedRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/new-case-related-request/:isPega/:caseObjectKey',
    name: 'select-case-related-request-with-case',
    component: SelectCaseRelatedRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/new-case-related-request/:isPega/:caseObjectKey/:requestObjectKey',
    name: 'select-case-related-request-with-case',
    component: SelectCaseRelatedRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseRelatedRequest,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/case-file/:isPega/:caseObjectKey',
    name: 'case-file',
    component: CaseFile,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.caseFile,
        isDynamic: false,
      },
    },
  },
  {
    path: '/written-pleading',
    name: 'WrittenPleading',
    component: WrittenPleading,
  },
  {
    path: '/cases/lawsuit-reply-form/:isPega/:caseObjectKey',
    name: 'LawsuitReplyForm',
    component: LawsuitReplyForm,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.replyToLawsuit,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/view-incoming-requests/:requestObjectKey',
    name: 'view-incoming-request',
    component: ViewIncomingRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.incomingRequests,
        isDynamic: false,
      },
      replyToRequest: false,
    },
  },
  {
    path: '/cases/petition-requests/:objectKey',
    name: 'PetitionRequests',
    component: PetitionRequests,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.petitionRequests,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/waiver/:caseObjectKey/:judgmentObjectKey',
    name: 'Waiver',
    component: Waiver,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.waiverRequest,
        isDynamic: false,
      },
    },
  },
  {
    path: '/cases/correction-decisions/:objectKey',
    name: 'CorrectionDecisions',
    component: CorrectionDecisions,
    meta: {
      breadcrumbs: {
        text: ar.common.correctionDecisions,
        isDynamic: false,
      },
    },
  },
];
